import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface OrderData {
  weightClass: string;
  deliveryPlan: string;
  securityCover: string;
  phlenuTrustCheck: string;
  packageContent: string;
  orderId?: string;
  orderStatus?: string;
  // Add more fields as needed based on API response
}

@Component({
  selector: 'app-get-qr-order-details',
  templateUrl: './get-qr-order-details.component.html',
  styleUrls: ['./get-qr-order-details.component.scss']
})
export class GetQrOrderDetailsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  data: OrderData = {
    weightClass: '',
    deliveryPlan: '',
    securityCover: '',
    phlenuTrustCheck: '',
    packageContent: '',
    orderId: '',
  };


  orderId: string = '';
  isLoading: boolean = false;
  hasError: boolean = false;
  errorMessage: string = '';
  dropId: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthServiceLocal,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    // Get order ID from route parameters
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.orderId = params['orderId'];
      this.dropId = params['dropId'];
      if (this.orderId) {
        this.loadOrderData();
      } else {
        this.hasError = true;
        this.errorMessage = 'Order ID is required';
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public loadOrderData(): void {
    if (!this.orderId) {
      this.hasError = true;
      this.errorMessage = 'Invalid Order ID';
      return;
    }

    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    // Call the API to get QR order details
    this.authService.getQrOrderDetails(this.orderId, this.dropId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response && response.response === 1) {
            this.mapApiResponseToData(response.data);
          } else {
            this.hasError = true;
            this.errorMessage = response?.message || 'Failed to load order details';
            this.snackBar.open(this.errorMessage, 'Close', { duration: 5000 });
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.hasError = true;
          this.errorMessage = 'Error loading order details. Please try again.';
          console.error('API Error:', error);
          this.snackBar.open(this.errorMessage, 'Close', { duration: 5000 });
        }
      });
  }

  private mapApiResponseToData(apiData: any): void {
    // Map API response to component data structure
    this.data = {
      orderId: this.orderId,
      weightClass: apiData.weightClass || 'Not Available',
      deliveryPlan: apiData.deliveryPlan || 'Not Available',
      securityCover: apiData.securityCover || 'Not Available',
      phlenuTrustCheck: apiData.phlenuTrustCheck || 'Not Available',
      packageContent: apiData.packageContent || 'Not Available',
    };
  }


}
